import React from 'react'
import {connect} from 'react-redux'
import {AutoMessageModel} from '/app/src/model'
import {Label, TextInput, SelectInput, Hint, NumberInput} from '/app/src/component'
import {H3, ToogleInput, SlideInput,  Flex, RadioInput, SVGButton} from '/app/src/component'
import {MarkdownEditor, Arrow} from '/app/src/component'
import {history} from '/app/src/store'
import DateTime from '/app/src/lib/DateTime'

class ItemView extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            title: props.title,
            message: props.message,
            priority: props.priority,
            url: props.url,
            time: props.time,
            visitor: props.visitor,
            weekDays: props.weekDays,
            frequency: props.frequency,
            msgDuration: props.msgDuration,
            changed: false
        }
        this._onCreate = this._onCreate.bind(this)
        this._onUpdate= this._onUpdate.bind(this)
        this._handleChange= this._handleChange.bind(this)
        this._handleTimeChange = this._handleTimeChange.bind(this)
        this.__addNewTimeTrigger = this.__addNewTimeTrigger.bind(this)
        this.__removeTimeTrigger = this.__removeTimeTrigger.bind(this)
    }

    _handleChange(event){
        let value = event.target.value
        if (event.target.name === 'msgDuration') {
            value = parseInt(value, 10)
        }
        this.setState({[event.target.name]: value, changed: true})
    }

    _renderProfile(){
        return (
            <Flex center width='90%' marginTop='40px'>
                <Label width='15%' marginRight='20px'> Profiler  <Hint paddingLeft='5px' position='top' tooltip='Välj bland förinställda profiler att utgå ifrån.'/></Label>
                <Flex>
                <RadioInput
                    values={['Dag', 'Kväll', 'Lunch', 'Helg']}
                    active='Dag'
                    onChange={this.__onProfileClick}
                />
                </Flex>
            </Flex>
        )
    }
    _renderContents(){
        return (
            <Flex column basis='100%'>
                <Label> Innehåll </Label>
                <H3 marginTop='20px'> Titel (Visas ej)
                <Hint paddingLeft='5px' position='right' tooltip='Namnge meddelandet med titel för att hålla koll på olika meddelanden (t.ex. “Lunch”, “Bemanningstider”, “Kontaktsida” etc.'/>
                </H3>
                <TextInput
                    value={this.state.title}
                    onChange={this._handleChange}
                    name='title'
                    placeholder='title'
                    grow={0}
                    marginTop='5px'
                />

                <H3 marginTop='20px'> Meddelande  <Hint paddingLeft='5px' position='right' tooltip='Skriv vad som ska visas automatiskt i chattbubblan på satta tider'/></H3>
                <MarkdownEditor
                    text={this.state.message}
                    onTextChange={(text) => this.setState({message: text, changed: true})}
                    height='220px'
                />
            </Flex>
        )
    }
    _handleTimeChange(index){
        return (value) => {
            let time = this.state.time
            time[index].time_before = DateTime.convertMinutesToHour(value.min)
            time[index].time_after = DateTime.convertMinutesToHour(value.max)
            this.setState({time: time, changed: true})
        }
    }
    __addNewTimeTrigger(){
        this.setState({time: [...this.state.time, {time_before: [0,0], time_after: [23,59]}], changed: true})
    }
    __removeTimeTrigger(index){
        return () => {
            let temp = []
            for(var i = 0; i < this.state.time.length; i++){
                if(i !== index){
                    temp.push(this.state.time[i])
                }
            }
            this.setState({time: temp, changed: true})
        }
    }

    __renderWeekDays(){
        return (
            <ToogleInput
                values={[
                    {value: 0, label: 'Må'},
                    {value: 1, label: 'Ti'},
                    {value: 2, label: 'On'},
                    {value: 3, label: 'To'},
                    {value: 4, label: 'Fr'},
                    {value: 5, label: 'Lö'},
                    {value: 6, label: 'Sö'}
                ]}
                active={this.state.weekDays}
                onChange={this._handleChange}
                name='weekDays'
            />
        )
    }
    __renderTimeTrigger(){
        let timeTriggers = []

        let __formatLabel = (value) => {
            let time = DateTime.convertMinutesToHour(value)
            time = time.map((value) => {
                if(value < 10){
                    return '0' + value.toString()
                }
                return value.toString()
            })
            time = time.join(':')
            return time
        }
        this.state.time.forEach((time, index) => {
            let minValue = time.time_before[0]*60 + time.time_before[1]
            let maxValue = time.time_after[0]*60 + time.time_after[1]
            timeTriggers.push(
                <Flex marginTop='50px' key={index}>
                    <SlideInput
                        formatLabel={__formatLabel}
                        minValue={0}
                        maxValue={1439}
                        value={{min: minValue, max: maxValue-1}}
                        onChange={this._handleTimeChange(index)}
                                            step={5}
                    />
                    <Flex width='50px' paddingLeft='20px'>
                {this.state.time.length > 1 && (
                    <SVGButton
                        onClick ={this.__removeTimeTrigger(index)}
                        src='/images/Trash.svg'
                        color='black'
                        hover='red'
                        size='medium'
                    />
                )}
                    </Flex>
                </Flex>
            )
        })
        return timeTriggers
    }
    _renderTrigger(){
        return (
            <Flex column basis='100%'>
                <Label> Villkor
                </Label>
                {/*<H3 marginTop='20px'> Visa för
                    <Hint paddingLeft='5px' position='right' tooltip='Välj vilka meddelandet ska visar för.'/>
                </H3>
                <SelectInput
                    values={{'all': 'Alla besökare','first': 'Förstagångs-besökare','recurring':'Återkommande besökare'}}
                    select={this.state.visitor}
                    onChange={this._handleChange}
                    name='visitor'
                />*/}

                <H3 marginTop='20px'> Begränsa visning
                    <Hint paddingLeft='5px' position='right' tooltip='Begränsa om meddelandet ska dyka upp varje gång sidan laddas eller bara en gång om dygnet.'/>
                </H3>
                <SelectInput
                    values={{'always': 'Visa vid varje besök','once24h':'Visa en gång per dygn', 'never': 'Visas inte'}}
                    select={this.state.frequency}
                    onChange={this._handleChange}
                    name='frequency'
                />

                <H3 marginTop='20px'> Visningstid (Sekunder)
                </H3>
                <NumberInput
                    value={this.state.msgDuration}
                    name='msgDuration'
                    w='70px'
                    onChange={this._handleChange}/>

                <H3 marginTop='20px'> Webbadress innehåller
                    <Hint paddingLeft='5px' position='right' tooltip='Sätt vilken sida automeddelandet ska gälla för. Exempelvis huvuddomän-adressen för allmänna meddelanden eller adress/nyckelord för delsidor, med mer specifika meddelanden såsom prisinfo, kontakt, support etc.'/>
                </H3>
                <Flex>
                    <TextInput
                        value={this.state.url}
                        onChange={this._handleChange}
                        name='url'
                    />
                </Flex>
                <H3 marginTop='20px'> Veckodagar
                    <Hint paddingLeft='5px' position='right' tooltip='Välj vilka veckodagar som automeddelandet ska kunna visas.'/>
                </H3>
                <Flex>
                {this.__renderWeekDays()}
                </Flex>
                <H3 marginTop='20px'> Tidsintervaller
                    <Hint paddingLeft='5px' position='right' tooltip='Sätt ett eller flera tidsintervaller under vilket automeddelandet visas.'/>
                </H3>
                <Flex w='90%' column>
                {this.__renderTimeTrigger()}
                </Flex>
                <SVGButton
                    marginLeft='auto'
                    marginTop='40px'
                    text='+'
                    fontSize='46px'
                    width='50px'
                    height='50px'
                    color='darkgrey'
                    backgroundColor='darkwhite'
                    backgroundHover='lightgrey'
                    borderRadius='10px !important'
                    onClick={this.__addNewTimeTrigger}
                />
            </Flex>
        )

    }

    _onCreate(){
        let msgDuration = this.state.msgDuration;
        let message = {
            message: this.state.message,
            title: this.state.title,
            priority: this.state.priority,
            delay: 0,
            frequency: this.state.frequency,
            message_duration: msgDuration?msgDuration:0
        }
        this.props.dispatch(AutoMessageModel.create(
            message,
            this.state.time,
            this.state.visitor,
            this.state.url,
            this.state.weekDays))
        history.push('/clientChat/autoMessage/')
    }

    _onUpdate(){
        let msgDuration = this.state.msgDuration;
        let message = {
            message: this.state.message,
            title: this.state.title,
            priority: this.state.priority,
            frequency: this.state.frequency,
            delay: 0,
            message_duration: msgDuration?msgDuration:0
        }
        this.props.dispatch(AutoMessageModel.update(
            this.props.id,
            message,
            this.state.time,
            this.state.visitor,
            this.state.url,
            this.state.weekDays))
    }

    render(){
        let buttonProps = {
            marginLeft: 'auto',
            marginRight: '10px',
            border: true,
            text: this.props.action==='edit'?'Spara':'Skapa',
            src: '/images/Save.svg',
            onClick: this.props.action==='edit'?this._onUpdate:this._onCreate,
            color: 'black',
            hover: 'blue',
            disabled: this.props.action === 'edit' && !this.state.changed,
        }

        return (
        <Flex width='100%' column hAlignContent='left' position='relative'>

            <Flex w='100%' backgroundColor='darkwhite'  basis='70px' vAlignContent='center' paddingLeft='20px'
            fontSize='18px' fontWeight='500' color='darkgrey'
            >
            <Arrow direction='left'
                borderRadius='100%'
                color='grey'
                hover='blue'
                onClick={() => history.push('/clientChat/autoMessage/')}
                text='Tillbaka till Automeddelande'
            />
            <SVGButton {...buttonProps}/>
            </Flex>
            <Flex column width='100%' hAlignContent='center' overflowY='auto' grow paddingBottom='50px'>
                <Flex shrink={0} w='100%' marginTop='50px' paddingRight='40px' paddingLeft='40px' wrap hAlignContent='center' >
                    <Flex basis='400px' hAlignContent='center' marginBottom='60px'>
                        {this._renderContents()}
                    </Flex>
                    <Flex w='40px'></Flex>
                    <Flex basis='400px' hAlignContent='center'>
                        {this._renderTrigger()}
                    </Flex >
                </Flex>
            </Flex>
        </Flex>
        )
    }
}


export default connect(null, null)(ItemView)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/AutoMessage/ItemScreen/ItemView.js